<div class="image" *ngFor="let image of context.images"
     [style.padding-right]="10 / columnCount + 'rem'">
    <app-image [context]="image"></app-image>
</div>



// WEBPACK FOOTER //
// /Users/tom/Projects/mercit2018/src/app/project/building-blocks/image-list/image-list.component.html